<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbwarehouseitem_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbwarehouseitem_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbwarehouseitem_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbwarehouseitem_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbwarehouseitem_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbwarehouseitem_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbwarehouseitem_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_state"
        class="form-control-label">state</label>
      <input
        id="exsbwarehouseitem_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_warehouse"
        class="form-control-label">warehouse</label>
      <input
        id="exsbwarehouseitem_warehouse"
        v-model="item.warehouse"
        :class="['form-control', isInvalid('warehouse') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('warehouse', $event.target.value)">
      <div
        v-if="isInvalid('warehouse')"
        class="invalid-feedback">{{ violations.warehouse }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_item"
        class="form-control-label">item</label>
      <input
        id="exsbwarehouseitem_item"
        v-model="item.item"
        :class="['form-control', isInvalid('item') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('item', $event.target.value)">
      <div
        v-if="isInvalid('item')"
        class="invalid-feedback">{{ violations.item }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbwarehouseitem_quantity"
        class="form-control-label">quantity</label>
      <input
        id="exsbwarehouseitem_quantity"
        v-model="item.quantity"
        :class="['form-control', isInvalid('quantity') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('quantity', $event.target.value)">
      <div
        v-if="isInvalid('quantity')"
        class="invalid-feedback">{{ violations.quantity }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
